import { Button, Form, Modal } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  emailPattern,
  getLocalStorageItem,
  mobilePattern,
} from "../../../Utils";
import { AEPS3GenerationLink } from "../../../ApiServices/Apifun";
import CommonInput from "../../../Common/CommonInput";
import { setselectedTab } from "../../../Store/B2bslice";
import { useNavigate } from "react-router-dom";
const AEPS4Component = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [transactionType, setTransactionType] = useState("");
  const formref = useRef();
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const navigate = useNavigate();
  const [openIframe, setOpenIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  useEffect(() => {
    dispatch(setselectedTab("1123.1"));
    if (!memberServices.includes("206")) {
      navigate("/not-available");
    }
  }, []);

  const handleAEPS3function = (val) => {
    let formdata = new FormData();
    {
      transactionType !== "MT" && transactionType !== "BW"
        ? formdata.append("amount", val.amount)
        : formdata.append("amount", 0);
    }
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    formdata.append("transaction_type", transactionType);
    AEPS3GenerationLink(formdata)
      .then((res) => {
        if (res.status) {
          setIframeUrl(res?.data?.checkoutUrl);
          setOpenIframe(true);
          // window.open(res?.data?.checkoutUrl, "_blank");
        }
      })
      .catch((err) => console.log(err));
    // .finally(() => setBtnLoading(false));
  };
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2"> AEPS 3</p>
          <Form
            name="form"
            form={form}
            ref={formref}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleAEPS3function(val)}
          >
            <Form.Item
              name={`transaction_type`}
              label={"Transaction Type"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select Transaction Type!",
                },
              ]}
            >
              <select
                className="w-full border border-gray-300 rounded-lg  text-sm"
                value={transactionType}
                onChange={(e) => setTransactionType(e.target.value)}
              >
                <option value="">----Select Transaction Type----</option>
                <option value="CW">CASH WITHDRAWAL</option>
                <option value="MT">MINI STATEMENT</option>
                <option value="BW">BALANCE ENQUIRY</option>
                <option value="AD">ADHAAR PAY</option>
                <option value="CD">CASH DEPOSIT</option>
              </select>
            </Form.Item>{" "}
            {transactionType !== "MT" && transactionType !== "BW" ? (
              <Form.Item
                name={`amount`}
                label={"Amount"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter amount",
                  },
                  {
                    whitespace: true,
                    message: "Amount cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Amount" name="amount" />
              </Form.Item>
            ) : (
              ""
            )}
            <Button
              loading={btnLoading}
              className="w-full bg-primary border-none mt-4"
              style={{ color: "white" }}
              htmlType="submit"
            >
              Continue
            </Button>
          </Form>
        </div>
        {iframeUrl && (
          <Modal
            open={openIframe}
            footer={null}
            onCancel={() => setOpenIframe(false)}
            width="80vw"
            bodyStyle={{
              padding: 0,
              height: "90vh",
            }}
            style={{
              top: 50,
              maxWidth: "90vw",
            }}
          >
            <iframe
              src={iframeUrl}
              title="AEPS Checkout"
              width="100%"
              height="100%"
              allow="geolocation; local-network-access; web-share"
              sandbox="allow-scripts allow-forms allow-same-origin allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-forms"
              allowFullScreen
              style={{ border: "none" }}
            />
          </Modal>
        )}
      </div>
    </>
  );
};

export default AEPS4Component;
